import { useLocation, useNavigate } from 'react-router-dom';
import Chart from 'chart.js/auto';
import { useEffect, useRef } from 'react';
import Layout from '../../Common/Layout';


const VARKResultPage = (props) => {
    const { state } = useLocation();
    const chartRef = useRef(null);
    const charInstance = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (charInstance.current) {
            charInstance.current.destroy();
        }

        const myChartRef = chartRef.current.getContext('2d');

        const VColor = 'rgba(143, 49, 58, 0.90)';
        const RColor = 'rgba(106, 136, 255, 0.90)';
        const KColor = 'rgba(0, 125, 89, 0.90)';
        const AColor = 'rgba(247, 203, 66, 0.90)';

        charInstance.current = new Chart(myChartRef, {
            type: 'bar',
            data: {
                labels: ["Visual", "Auditory", "Read/Write", "Kinesthetic"],
                datasets: [
                    {
                        label: "Learning Styles",
                        data: [state.VARKResults.V, state.VARKResults.A, state.VARKResults.R, state.VARKResults.K],
                        backgroundColor: [VColor, AColor, RColor, KColor],
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    },
                },
                scales: {
                    x: {
                        display: true,
                        ticks: {
                            color: 'black',
                        },
                    },
                    y: {
                        display: true,
                        ticks: {
                            color: 'black',
                        },
                    },
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
            },
        });

        return () => {
            if (charInstance.current) {
                charInstance.current.destroy();
            }
        };
    }, [state.VARKResults.V, state.VARKResults.A, state.VARKResults.R, state.VARKResults.K]);

    function bookAppointment() {
        navigate('/booking');
    }

    return (
        <Layout>
            <div className='resultsContainer'>
                <h1 className='resultsHeading'>Your results are ready!🎉</h1>
                <div className='resultsText'>
                    Based on the questions you answered, here is the breakdown of your preferred learning styles across 4 options.
                    Feel free to explore further details!
                </div>
                <div className="chartContainer">
                    <div>
                        <canvas id="myChart" ref={chartRef} className='ResultsBarGraph'></canvas>
                    </div>
                </div>
            </div>

            <div className='bookingContainer'>
                <div className='counsellingHeading'>
                    Still confused? </div>
                <div className='counsellingText'>Book a counseling session for one-on-one personal guidance!</div>

                <button className='bookAppointment' onClick={() => bookAppointment()}>Book Appointment</button>
            </div>
        </Layout>
    );
};

export default VARKResultPage